$(document).ready(function () {
    console.log("Subscription Widget geladen");

    function formatMoney(amount) {
        // Zeige .00 nur wenn nötig, sonst .-
        if (amount % 1 === 0) {
            return Math.floor(amount) + ".-";
        } else {
            return new Intl.NumberFormat("de-CH", { style: "decimal", minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(amount);
        }
    }

    // Initialisiert Subscription-Optionen
    function initializeSubscriptionOptions() {
        if ($('.selling_plan').length > 0) {
            var initialPlan = $('.selling_plan option:selected').val();
            $('#selling_plan_id').val(initialPlan);
        }
        $('.subscription-input:checked').trigger('change');
    }

    // Aktualisiert die Preise für Subscription & Bundle
    function updateSubscriptionPrice() {
        $('.product-subscription').each(function () {
            let productContainer = $(this);
            let productPrice = parseFloat(productContainer.find(".single-price").text().replace(".-", "").replace(",", "."));

            if (isNaN(productPrice) || productPrice <= 0) {
                console.warn(`Produktpreis konnte nicht geladen werden.`);
                return;
            }

            let bundleDiscount = 0.33;
            let subscriptionDiscount = 0.15;

            let bundlePrice = (productPrice * 2);
            let subscriptionPrice = productPrice * (1 - subscriptionDiscount);

            productContainer.find(".bundle-price .reg_price").text(formatMoney(bundlePrice));
            productContainer.find(".subs-price .reg_price").text(formatMoney(subscriptionPrice));

            productContainer.find(".bundle-price del").text(formatMoney(productPrice * 3));
            productContainer.find(".subs-price del").text(formatMoney(productPrice));
        });
    }

    // Aktualisiert die Menge je nach Subscription-Typ
    function updateCartQuantity() {
        $('.product-subscription').each(function () {
            let productContainer = $(this);
            let selectedOption = productContainer.find('input[name="subscription"]:checked').val();
            let quantityInput = $('.quantity__input');

            if (selectedOption === 'bundle') {
                quantityInput.removeAttr('disabled').val(3);
            } else {
                quantityInput.attr('disabled', 'disabled').val(1);
            }
        });
    }

    // Setzt das `selling_plan_id` Feld korrekt
    function updateSellingPlanId() {
        $('.product-subscription').each(function () {
            let productContainer = $(this);
            let selectedOption = productContainer.find('input[name="subscription"]:checked').val();
            let oName = selectedOption;

            console.log('oName ' + oName);

            if (oName === 'subscription') {
                let sellingPlanId = productContainer.find(".selling_plan option:selected").val();
                if (sellingPlanId) {
                    $("#selling_plan_id").val(sellingPlanId);
                    console.log("✅ selling_plan_id gesetzt:", sellingPlanId);
                } else {
                    console.error("❌ Fehler: selling_plan_id ist leer!");
                }
            } else {
                $("#selling_plan_id").val('');
            }
        });
    }

    // Initialisiere Subscription-Optionen & Preise beim Laden
    initializeSubscriptionOptions();
    updateSubscriptionPrice();

    $(".subscription-loading-overlay").fadeOut(300);

    // Event-Listener für Subscription-Optionen
    $('.subscription-input, .selling_plan').on('change', function () {
        $(this).closest('.subscription-item').addClass('active').siblings().removeClass('active');

        updateCartQuantity();
        updateSellingPlanId();
        updateSubscriptionPrice();
    });

    // Aktualisiere bei Variantenwechsel
    $(document).on('variant:change', function () {
        initializeSubscriptionOptions();
        updateCartQuantity();
        updateSubscriptionPrice();
        updateSellingPlanId();
    });

    // Setzt `selling_plan_id` korrekt beim Warenkorb hinzufügen
    $("form[action='/cart/add']").on("submit", function () {
        updateCartQuantity();
        updateSellingPlanId();
        let sellingPlan = $("#selling_plan_id").val();
        console.log("🛒 Wird in den Warenkorb gesendet: selling_plan_id =", sellingPlan);
    });
});
